import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout'
import UserGroupForm from '../../components/UserGroupForm';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';


export default function UserGroupEdit() {
  return (
    <div style={{ margin: '2rem' }}>
      <AdminLayout />
      <Grid container style={{ marginTop: '4rem', marginBottom: '2rem' }}>
        <Grid item xs={12}>
          <Typography variant='h4' style={{ fontWeight: 'bold' }}>Edit User Group</Typography>
        </Grid>
        <Grid item xs={12} >
          <UserGroupForm 
            mode='edit'
          />
        </Grid>
      </Grid>
    </div>
  )
}